import React from 'react';

export default function StepperControl({ handleClick, currentStep, steps, handleSubmit}) {
  const handleBackClick = () => {
    handleClick("back");
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNextClick = () => {
    if(currentStep === steps.length - 1)
      handleClick("confirm");
    else 
      handleClick("next")
    window.scrollTo({ top: 0, behavior: 'smooth' });
    handleSubmit(); // Call the submitForm function
  };

  return (
    <div className="container mt-4 mb-8 flex justify-around">
      <button
        onClick={handleBackClick}
        className={`cursor-pointer rounded-xl border-2 border-slate-300 py-2 px-4 font-semibold uppercase text-slate-400 transition duration-200 ease-in-out ${
          currentStep === 1
            ? "bg-gray-300 cursor-not-allowed opacity-50"
            : "bg-white hover:bg-slate-700 hover:text-white"
        }`}
      >
        Back
      </button>
      <button
        onClick={handleNextClick}
        className="cursor-pointer rounded-md bg-blue-600 py-2 px-4 font-semibold uppercase text-white transition duration-200 ease-in-out hover:bg-blue-400 hover:text-white"
      >
        {currentStep === steps.length - 1 ? "Confirm" : "Next"}
      </button>
    </div>
  );
}
